import { EconomySave, EconomySaveIcon } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { BoxEconomyModeOff } from '../styles';

interface EconomyMode {
  isOpen: boolean;
  onClose: () => void;
  actionButton1: () => void;
}

export const ModalEconomyModeOff: React.FC<EconomyMode> = ({ isOpen, onClose, actionButton1 }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('desejaDesligarModoEconomia')}
      title={t('desligarModoEconomia')}
      iconTitle={<EconomySave />}
      button1={t('confirmar')}
      button1Action={actionButton1}
      button2={t('cancelar')}
      button2Action={onClose}
      centralizedText
      imageText={(
        <BoxEconomyModeOff>
          <div>
            {t('penseAntesDeDesligar')}
          </div>
          <EconomySaveIcon />
        </BoxEconomyModeOff>
      )}
    />
  );
};
